<template>
  <div v-if="hasAffiliations">
    <AthleteSectionSubheading>Teams</AthleteSectionSubheading>
    <div class="grid gap-6 mb-8 lg:grid-cols-3">
      <AthleteTeamCard
        v-for="(affiliation, index) in shownAffiliations"
        :key="index"
        class="w-full"
        :affiliation="affiliation"
        :showLinks="showLinks"
      />
    </div>
  </div>
</template>

<script>
import AthleteTeamCard from "./Card";
import AthleteSectionHeading from "@/components/AthleteProfile/AthleteSectionHeading";
import { mapState, mapGetters } from "vuex";
import AthleteSectionSubheading from "@/components/AthleteProfile/AthleteSectionSubheading";
import sortBy from "lodash/sortBy";

export default {
  components: {
    AthleteTeamCard,
    AthleteSectionHeading,
    AthleteSectionSubheading
  },
  props: {
    showLinks: { required: false, default: true, type: Boolean }
  },
  computed: {
    ...mapGetters("athleteProfile", {
      integratedAffiliations: "organizationAffiliations",
      teamAffiliations: "teamAffiliations",
      nonIntegratedAffiliations: "nonIntegratedAffiliations"
    }),

    teams() {
      let teams = [];
      this.teamAffiliations.forEach(team => {
        teams.push( {
          id: team.id,
          name: team.team.name,
          organization_id: team.team.organization_id,
          isIntegrated: true,
          jerseyNumber: team.jerseyNumber,
          organization: team.team.organization,
          type: "teamAffiliations"
        })
      })

      teams = _.sortBy(teams, ['organization_id', 'name']);
      return teams;
    },

    shownAffiliations() {
      return [
        ...this.teams,
        ...this.integratedAffiliations.filter(aff => !this.isDuplicateTeam(aff)), // function returns true if the team matches, so we don't want it, so we single bang the result
        ...this.nonIntegratedAffiliations.filter(aff => !this.isSuperseded(aff))
      ];
    },

    hasAffiliations() {
      return this.shownAffiliations.length;
    }
  },

  methods: {
    isDuplicateTeam({organization: {id}}) {
      return !!this.teams.filter(team => team.organization.id == id);
    },
    isSuperseded(nonIntegratedAffiliation) {
      return this.integratedAffiliations
          .map(aff => aff.organization.kind)
          .includes(nonIntegratedAffiliation.type);
    }
  }
};
</script>

<style scoped>
</style>